import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // StrictMode disabled: it double-mounts in dev, causing WS connect→cleanup→connect
  // cycle and dropping tr_progress messages. Re-enable for other dev checks if needed.
  <App />
);

reportWebVitals();
